/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { DOCUMENT } from "@angular/common";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { registerMap } from "echarts";
import { map, shareReplay, tap } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class WorldMapService {
	private _http = new HttpClient(inject(HttpBackend));
	private _assetUrl = new URL("config/echarts/map/world.json", inject(DOCUMENT).baseURI).href;
	private _ready$ = this._http.get<Parameters<typeof registerMap>[1]>(this._assetUrl).pipe(
		tap(geoJson => registerMap("world", geoJson)),
		map(() => undefined),
		shareReplay({ bufferSize: 1, refCount: false })
	);

	public load() {
		return this._ready$;
	}
}
